import script from "./AlleBerechnungen.vue?vue&type=script&setup=true&lang=js"
export * from "./AlleBerechnungen.vue?vue&type=script&setup=true&lang=js"

import "./AlleBerechnungen.vue?vue&type=style&index=0&id=1193de4d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1193de4d"]])

export default __exports__